/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect } from "react"

import { faGear, faTriangleExclamation } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import {
  GenericConfirmDialogIconTemplate,
  useGenericConfirmDialog,
} from "@finanedi.es/front/common/atoms"

import { LeyAntiFraudeFormModal } from "../ley-antifraude-form-modal"
import { useLeyAntifraudeConfiguracionRequerida } from "./hooks"
import { LeyAntifraudeConfiguracionRequeridaProps } from "./interfaces"

export const LeyAntifraudeConfiguracionRequerida = ({
  configurarLeyAntifraudeDefinitivo = false,
}: LeyAntifraudeConfiguracionRequeridaProps) => {
  const { genericConfirmDialogShow } = useGenericConfirmDialog()
  const {
    isConfirmDialogOpen,
    handleConfirm,
    handleCancel,
    isConfigModalOpen,
    handleCloseConfigModal,
    nif,
    razonSocial,
    message,
  } = useLeyAntifraudeConfiguracionRequerida(configurarLeyAntifraudeDefinitivo)

  const showConfiguracionRequeridaModal = useCallback(() => {
    genericConfirmDialogShow({
      message: message as any,
      header: "",
      className: "fs-p-2 tablet:fs-p-4 laptop:fs-p-6",
      icon: (() =>
        GenericConfirmDialogIconTemplate({
          icon: faTriangleExclamation as any,
          bgColor: "fs-bg-white",
          iconColor: "fs-text-danger",
          subHeader: "Configuración requerida",
        })) as any,
      accept: handleConfirm,
      reject: handleCancel,
      onHide: handleCancel,
      acceptLabel: "Ir a configurar ley antifraude",
      rejectLabel: "Cancelar",
      rejectClassName: configurarLeyAntifraudeDefinitivo ? "fs-hidden" : "",
      acceptIcon: (<FontAwesomeIcon icon={faGear} />) as any,
      closable: !configurarLeyAntifraudeDefinitivo,
    })
  }, [
    genericConfirmDialogShow,
    handleConfirm,
    handleCancel,
    configurarLeyAntifraudeDefinitivo,
    message,
  ])

  useEffect(() => {
    if (isConfirmDialogOpen) {
      showConfiguracionRequeridaModal()
    }
  }, [isConfirmDialogOpen, showConfiguracionRequeridaModal])

  return (
    <>
      {isConfigModalOpen && (
        <LeyAntiFraudeFormModal
          isOpen={isConfigModalOpen}
          handleCloseModal={handleCloseConfigModal}
          nif={nif}
          razonSocial={razonSocial}
        />
      )}
    </>
  )
}
